import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"

import sponsorBrighthair from "../../assets/images/logo/sponsor_brighthair.webp"
import sponsorParabola from "../../assets/images/logo/sponsor_parabola.webp"
import sponsorPocari from "../../assets/images/logo/sponsor_pocari.webp"

const useStyle = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F2F2F2",
    padding: `${theme.spacing(6)}px ${theme.spacing(4)}px`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(4)}px ${theme.spacing(2)}px`
    }
  },
  title: {
    marginBottom: theme.spacing(4),
    textAlign: "center",
    color: theme.palette.gray[700],
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.75rem",
      marginBottom: theme.spacing(3)
    }
  },
  sponsorContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  sponsorImage: {
    height: "100px",
    width: "auto",
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      height: "80px"
    },
    [theme.breakpoints.down("sm")]: {
      height: "70px"
    }
  }
}))

const HomeSponsor: React.FC = () => {
  const classes = useStyle()

  return (
    <div className={classes.container}>
      <Typography variant="h2" className={classes.title}>
        ผู้สนับสนุนหลักค่ายลานเกียร์ครั้งที่ 25
      </Typography>
      <div className={classes.sponsorContainer}>
        <img src={sponsorParabola} alt="Parabola Sponsor" className={classes.sponsorImage} />
        <img src={sponsorBrighthair} alt="Bright Hair Sponsor" className={classes.sponsorImage} />
        <img src={sponsorPocari} alt="Pocari Sponsor" className={classes.sponsorImage} />
      </div>
    </div>
  )
}

export default HomeSponsor

